import React from 'react'
import RESOURCE_TYPES from '../../../constants/resource-types'
import { values, capitalize } from 'lodash'
import CheckedMultiSelector from '../../common/checked-multi-selector'
import useLearningResourcesFilters from '../../../hooks/use-learning-resources-filters'

const ResourceTypesFilter = ({
    disabled
}) => {
    const { types: valuesArray, updateFilters } = useLearningResourcesFilters()
    const types = values(RESOURCE_TYPES).map(type => ({ id: type, name: capitalize(type) }))
    return (
        <React.Fragment>
            <CheckedMultiSelector
                items={types}
                title={valuesArray.length ? 'Types' : 'All Types'}
                onChange={l => updateFilters({ types: l})}
                values={valuesArray || []}
                disabled={disabled}
                keyProp='id'
                valueProp='name'
            />
        </React.Fragment>
    )
}

export default ResourceTypesFilter